import React, { useState } from "react";
import posthog from "posthog-js";
import { PORTAL_BASE_URL, REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../../env";
import ASSETS from "../assets.json";
import "./HeroSection.scss";

const ASSET_TYPES = [
    { key: "image",   label: "Image",   icon: ASSETS.hero.iconImage,   iconSize: 16 },
    { key: "video",   label: "Video",   icon: ASSETS.hero.iconVideo,   iconSize: 20 },
    { key: "spatial", label: "Spatial 3D", icon: ASSETS.hero.iconSpatial, iconSize: 20 },
];

const COLUMNS = [
    {
        cls: "lv2-gallery-col-1",
        images: [
            { src: ASSETS.hero.galleryCol1[0], height: 180, radius: 8 },
            { src: ASSETS.hero.galleryCol1[1], height: 450, radius: 24 },
            { src: ASSETS.hero.galleryCol1[2], height: 322, radius: 24 },
            { src: ASSETS.hero.galleryCol1[3], height: 180, radius: 24 },
            { src: ASSETS.hero.galleryCol1[4], height: 322, radius: 24 },
        ],
    },
    {
        cls: "lv2-gallery-col-2",
        images: [
            { src: ASSETS.hero.galleryCol2[0], height: 322, radius: 8 },
            { src: ASSETS.hero.galleryCol2[1], height: 483, radius: 24 },
            { src: ASSETS.hero.galleryCol2[2], height: 180, radius: 24 },
            { src: ASSETS.hero.galleryCol2[3], height: 322, radius: 8 },
        ],
    },
    {
        cls: "lv2-gallery-col-3",
        images: [
            { src: ASSETS.hero.galleryCol3[0], height: 180, radius: 8 },
            { src: ASSETS.hero.galleryCol3[1], height: 573, radius: 24 },
            { src: ASSETS.hero.galleryCol3[2], height: 322, radius: 24 },
            { src: ASSETS.hero.galleryCol3[3], height: 322, radius: 8 },
        ],
    },
    {
        cls: "lv2-gallery-col-4",
        images: [
            { src: ASSETS.hero.galleryCol4[0], height: 322, radius: 8 },
            { src: ASSETS.hero.galleryCol4[1], height: 180, radius: 24 },
            { src: ASSETS.hero.galleryCol4[2], height: 322, radius: 24 },
            { src: ASSETS.hero.galleryCol4[3], height: 577, radius: 24 },
        ],
    },
];

const handleStartFree = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const email     = urlParams.get("email") || "";
    let utm_source  = localStorage.getItem("utm_source") || urlParams.get("utm_source");

    const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
        api_host: POSTHOG_API_HOST,
        autocapture: false,
        name: "register",
        capture_pageview: false,
        disable_session_recording: true,
        loaded: (ph) => {
            if (utm_source) ph.register({ utm_source: utm_source });
        },
    });
    if (!utm_source) utm_source = "direct";
    if (ph) {
        ph.capture("free_trial_click", {
            location: window.location.pathname,
            button:   "try_ai_images_for_free",
            utm_source,
            email,
        });
    }

    const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services&utm_source=${utm_source}`;
    window.location.href = `${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`;
};

const HeroSection = () => {
    const [activeType, setActiveType] = useState("image");

    return (
        <div className="lv2-hero-wrapper">
            {/* Radial blue gradient behind the heading */}
            <div className="lv2-hero-bg" />

            {/* Heading */}
            <div className="lv2-hero-heading">
                <h1 className="manrope w-600 white lv2-hero-title">
                    AI assets for your store,<br />fast and accurate
                </h1>
                <p className="manrope f-20 w-500 lh-28 white lv2-hero-subtitle">
                    Generate product images, videos, and marketing assets with control in minutes.
                </p>
            </div>

            {/* Scrolling image gallery */}
            <div className="lv2-gallery">
                <div className="lv2-gallery-columns">
                    {COLUMNS.map((col, ci) => (
                        <div key={ci} className={`lv2-gallery-col ${col.cls}`}>
                            {col.images.map((img, ii) => (
                                <div
                                    key={ii}
                                    className="lv2-gallery-img"
                                    style={{ height: img.height, borderRadius: img.radius }}
                                >
                                    <img src={img.src} alt="" />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {/* Floating input / CTA bar */}
            <div className="lv2-input-bar">
                <p className="manrope f-16 w-500 lh-24 white lv2-input-label">
                    What asset do you need today?
                </p>

                <div className="lv2-asset-tabs">
                    {ASSET_TYPES.map((type) => (
                        <button
                            key={type.key}
                            className={`lv2-asset-tab ${activeType === type.key ? "active" : ""}`}
                            onClick={() => setActiveType(type.key)}
                        >
                            <img
                                src={type.icon}
                                alt={type.label}
                                style={{ width: type.iconSize, height: type.iconSize }}
                            />
                            <span className="manrope f-14 w-500 lh-22 white">{type.label}</span>
                        </button>
                    ))}
                </div>

                <button className="lv2-start-btn manrope f-14 w-500 lh-22 white" onClick={handleStartFree}>
                    Start Free
                </button>
            </div>
        </div>
    );
};

export default HeroSection;
